export default __webpack_public_path__ + "darkMap.png";